import { api } from "@/lib/api-client";
import { uploadsApi } from "@/features/uploads/api";
import type { Partner, PartnerInput } from "./types";

function toPayload(input: PartnerInput) {
  return {
    name: input.name,
    slug: input.slug || undefined,
    websiteUrl: input.websiteUrl || null,
    logoKey: input.logoKey || null,
    blurb: input.blurb || null,
    featured: input.featured ?? false,
    sortOrder: input.sortOrder ?? 0,
    isActive: input.isActive ?? true,
  };
}

export const partnersApi = {
  publicList: () => api.get<Partner[]>("/partners"),
  list: () => api.get<Partner[]>("/partners/manage"),
  create: async (input: PartnerInput, logoFile?: File | null) => {
    const logo = logoFile ? await uploadsApi.image(logoFile) : null;
    return api.post<Partner>("/partners", toPayload({ ...input, logoKey: logo?.key ?? input.logoKey }));
  },
  update: async (id: string, input: PartnerInput, logoFile?: File | null) => {
    const logo = logoFile ? await uploadsApi.image(logoFile) : null;
    return api.patch<Partner>(`/partners/${id}`, toPayload({ ...input, logoKey: logo?.key ?? input.logoKey }));
  },
  delete: (id: string) => api.delete<void>(`/partners/${id}`),
};
